import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheckIcon } from 'lucide-react';
export function RiskReversal() {
  return <SectionWrapper className="bg-white py-10" data-id="element-266">
      <div className="bg-white p-8 md:p-12 rounded-xl text-center max-w-3xl mx-auto border-4 border-double border-sage shadow-soft" data-id="element-267">
        <div className="flex justify-center mb-6" data-id="element-268">
          <ShieldCheckIcon className="w-16 h-16 text-sage" data-id="element-269" />
        </div>

        <h2 className="font-sans text-3xl font-bold text-ink mb-2" data-id="element-270">
          GARANTÍA CALMA TOTAL
        </h2>

        <p className="font-sans text-lg font-medium text-sage mb-8" data-id="element-271">
          7 días — devolución sin preguntas
        </p>

        <hr className="border-hairline w-24 mx-auto mb-8" data-id="element-272" />

        <div className="space-y-4 font-sans text-lg text-ink-mid max-w-xl mx-auto mb-8" data-id="element-273">
          <p data-id="element-274">Lee el protocolo completo.</p>
          <p data-id="element-275">Aplícalo en una crisis real.</p>
          <p data-id="element-276">
            Si sientes que no te dio absolutamente nada de valor, escríbenos y
            te devolvemos cada centavo.
          </p>
        </div>

        <div className="font-sans font-bold text-ink text-lg space-y-2 mb-8" data-id="element-277">
          <p data-id="element-278">Sin formularios.</p>
          <p data-id="element-279">Sin explicaciones.</p>
          <p data-id="element-280">Sin demoras.</p>
        </div>

        <hr className="border-hairline w-24 mx-auto mb-8" data-id="element-281" />

        <p className="font-sans font-bold text-ink text-xl" data-id="element-282">
          Riesgo cero de tu parte. Todo el riesgo es nuestro.
        </p>
      </div>
    </SectionWrapper>;
}